import { render, staticRenderFns } from "./downSysOrder.vue?vue&type=template&id=26fa19b2&scoped=true&"
import script from "./downSysOrder.vue?vue&type=script&lang=js&"
export * from "./downSysOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa19b2",
  null
  
)

export default component.exports